/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021, 2025
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import * as operations from '../operations';

const initialState = {
  action_variables: {},
  actions: {},
  counterExamples: {},
  default_content: {},
  entities: {},
  examples: {},
  integrationDefinitions: {},
  integrationInstances: {},
  integrationTemplates: {},
  intents: {},
  instance: {},
  try_it_messages: {},
  sample_content: {},
  steps: {},
  sub_actions: {},
  skills: {},
  variables: {},
  variables_system: {},
  webhooks_notifiers: {},
  webhooks_processors: {},
  workspaces: {},
  storeSteps: {} //Meant to hold a state of what is in store, not updated until steps are saved
};

const getEntities = action => {
  let entities = null;

  if (action.response && action.response.entities) {
    entities = action.response.entities;
  } else if (
    action.payload &&
    action.payload.response &&
    action.payload.response.entities
  ) {
    entities = action.payload.response.entities;
  }

  return entities;
};

export const getOperation = action =>
  action.payload ? action.payload.operation : '';

export const addEntities = (state, entities) => {
  const newState = Object.assign({}, state);
  const types = Object.keys(entities);

  types.forEach(type => {
    const ids = Object.keys(entities[type]);
    newState[type] = Object.assign({}, state[type]);

    ids.forEach(id => {
      newState[type][id] = entities[type][id];
    });
  });

  return newState;
};

export const replaceEntities = (state, entities) => {
  const newState = Object.assign({}, state);
  const types = Object.keys(entities);

  types.forEach(type => {
    const ids = Object.keys(entities[type]);
    newState[type] = Object.assign({}, state[type]);
    ids.forEach(id => {
      newState[type][id] = entities[type][id];
    });
  });

  return newState;
};

export const removeEntities = (state, entities) => {
  const newState = Object.assign({}, state);
  const types = Object.keys(entities);

  types.forEach(type => {
    const ids = Object.keys(entities[type]);
    newState[type] = Object.assign({}, state[type]);
    ids.forEach(id => {
      delete newState[type][id];
    });
  });

  return newState;
};

export const resetEntities = (state, entities) => {
  const newState = Object.assign({}, state);
  const types = Object.keys(entities);

  types.forEach(type => {
    newState[type] = initialState[type];
  });

  return newState;
};

export const reducer = (state = initialState, action) => {
  const entities = getEntities(action);
  const operation = getOperation(action);

  if (entities) {
    switch (operation) {
      case operations.CREATE:
        return addEntities(state, entities);
      case operations.GET:
        return addEntities(state, entities);
      case operations.UPDATE:
        return replaceEntities(state, entities);
      case operations.DELETE:
        return removeEntities(state, entities);
      case operations.RESET:
        return resetEntities(state, entities);
      default:
        return Object.assign({}, state, entities);
    }
  }

  return state;
};
